// removed by extract-text-webpack-plugin
module.exports = {"avatar":"xO43tloPMxjO57b1u9bET","reviewedByLabel":"_1dv769eAkXV5GkY-3YPQvO"};


//////////////////
// WEBPACK FOOTER
// ./src/components/opportunityTagsReviewed.less
// module id = 626
// module chunks = 0